import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Output,
} from '@angular/core';

/**
 * Directive that emits an event when the HTML content inside the element is ready.
 * This directive is useful when we cannot rely on `ngAfterViewInit` as some components are added dynamically through Renderer.
 */
@Directive({
  selector: '[dotHtmlReady]',
})
export class HtmlReadyDirective implements AfterViewInit {
  @Output() htmlReady = new EventEmitter<void>();

  constructor(private el: ElementRef) {}

  /**
   * Lifecycle hook that is called after the view has been initialized.
   * It sets up a MutationObserver to detect changes in the element's child nodes.
   * When new nodes are added, the `htmlReady` event is emitted.
   */
  ngAfterViewInit() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        requestAnimationFrame(() => {
          if (mutation.addedNodes.length > 0) {
            this.htmlReady.emit();
            observer.disconnect();
          }
        });
      });
    });

    observer.observe(this.el.nativeElement, { childList: true, subtree: true });
  }
}
